import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AwsService } from '../../services/awsService';

export const authenticate = createAsyncThunk(
    'authentication/authenticate',
    async (authInfo: {username: string, password: string}) => {
        const awsService = new AwsService();
        const authResult = await awsService.authenticate(authInfo);
        if (authResult) {
            return { ...authResult };
        } else {
            return undefined;
        }
    }
);

export const refreshToken = createAsyncThunk(
    'authentication/refreshToken',
    async () => {
        const awsService = new AwsService();
        const authResult = await awsService.refeshAuth();
        if (authResult) {
            return { ...authResult };
        } else {
            return undefined;
        }
    }
);


export const dismissError = createAction<void>('authentication/dismissError');

// export const unauthenticate = createAction<void>('authentication/unauthenticate');
export const unauthenticate = createAsyncThunk(
    'authentication/unauthenticate',
    async () => {
        const awsService = new AwsService();
        return await awsService.unauthenticate();
    }
);





// export const setTeams = createAction<Team[]>('data/setTeams',);
